// Fake-door pricing A/B (docs/gtm-playbook.md §6 / §T-a).
//
// The open pricing question is the *metric*, not the number: do teams prefer
// paying **per seat** or a **flat per-workspace** rate (unlimited seats)? This
// assigns each workspace to one of the two arms and derives the flat price, so
// the fake-door `upgrade-intent` funnel (PlanPanel.js) can be split by arm and
// read as a willingness-to-pay signal during the launch spike.
//
// Assignment is a deterministic hash of the workspace id — stable across
// sessions/devices with no storage or network, and keyed on the *workspace*
// (not the user) so a whole team consistently sees the same pricing. Billing is
// in Stripe stub mode; nothing is ever charged here — the click is the data.
//
// Scope: the A/B is on the **Team** tier only. Enterprise is sales-led
// (contact-us on both the storefront and the in-app panel — the billing
// catalog's `salesLed` flag), so it carries no self-serve flat price and is
// excluded from the map below.

// Flat monthly price (whole workspace, unlimited seats), USD, per paid tier.
// Mirrors the PRICING section of the marketing storefront. Fake-door only.
export const FLAT_MONTHLY_USD = { team: 99 };

// Deterministic 0/1 bucket from a string id (FNV-1a → unsigned → mod 2), so the
// ~50/50 split is stable without any persistence.
export function pricingVariant(workspaceId) {
  const key = String(workspaceId ?? '');
  let h = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) % 2 === 0 ? 'per_seat' : 'flat';
}
